const OFFERINGS = [
  {
    label: "Beans",
    title: "Single-origin bags",
    body: "Rotating lots from Ethiopia, Colombia, and Guatemala. Roasted and shipped within 48 hours.",
    cta: "Shop Coffee",
    href: "#coffee",
    icon: "ri-plant-line",
    image:
      `${import.meta.env.BASE_URL}localized/offering-beans-01.jpg`,
  },
  {
    label: "Cafe",
    title: "Our Portland roomery",
    body: "A quiet counter serving pour-overs, espresso, and pastries baked next door each morning.",
    cta: "Plan a Visit",
    href: "#visit",
    icon: "ri-cup-line",
    image:
      `${import.meta.env.BASE_URL}localized/offering-cafe-01.jpg`,
  },
  {
    label: "Subscription",
    title: "Coffee at your door",
    body: "Two bags a month, curated by our head roaster. Skip, swap, or cancel — no fine print.",
    cta: "Begin a Ritual",
    href: "#coffee",
    icon: "ri-calendar-schedule-line",
    image:
      `${import.meta.env.BASE_URL}localized/offering-subscription-01.jpg`,
  },
];

export default function CoreOfferings() {
  return (
    <section className="w-full bg-background-50 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16 reveal">
          <span className="text-xs tracking-[0.35em] uppercase text-accent-700">Three Ways In</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-4 leading-tight">
            However you like your <em>morning.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {OFFERINGS.map((o, idx) => (
            <article
              key={o.label}
              className="group relative flex flex-col bg-background-100 rounded-lg overflow-hidden reveal border border-background-200/60 hover:border-accent-400 transition-colors"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={o.image}
                  alt={o.title}
                  className="w-full h-full object-cover object-top transition-transform duration-1000 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 text-[10px] tracking-[0.35em] uppercase bg-background-50 text-primary-900 px-3 py-1.5 rounded-full">
                  {o.label}
                </span>
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-5">
                  <i className={`${o.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-2xl text-primary-950 mb-3">{o.title}</h3>
                <p className="text-foreground-700 text-sm leading-relaxed flex-1">{o.body}</p>
                <a
                  href={o.href}
                  className="mt-6 inline-flex items-center gap-2 text-sm text-primary-900 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap border-b border-primary-900 pb-1 w-fit"
                >
                  <span>{o.cta}</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}